(function () {
  var STORAGE_KEY = 'ts_wishlist_count'
  var bound = false

  function paintCount(count) {
    var n = parseInt(count, 10)
    if (isNaN(n) || n < 0) n = 0

    document.querySelectorAll('#wishlistcount, .js-wishlist-count').forEach(function (countEl) {
      countEl.textContent = String(n)
      countEl.style.display = n > 0 ? '' : 'none'
    })
  }

  function readCachedCount() {
    try {
      return localStorage.getItem(STORAGE_KEY)
    } catch (e) {
      return null
    }
  }

  function writeCachedCount(count) {
    try {
      localStorage.setItem(STORAGE_KEY, String(count))
    } catch (e) {}
  }

  function paintCachedCount() {
    var cached = readCachedCount()
    if (cached !== null) paintCount(cached)
  }

  function updateWishlistCount(swat) {
    if (!swat || typeof swat.fetch !== 'function') return

    swat.fetch(function (products) {
      var count = products && products.length ? products.length : 0
      writeCachedCount(count)
      paintCount(count)
    })
  }

  function bindWishlistCountEvents(swat) {
    if (!swat || bound) {
      updateWishlistCount(swat)
      return
    }
    bound = true

    updateWishlistCount(swat)

    if (!swat.evtLayer || typeof swat.evtLayer.addEventListener !== 'function') return

    var events = []
    if (swat.JSEvents) {
      if (swat.JSEvents.addedToWishlist) events.push(swat.JSEvents.addedToWishlist)
      if (swat.JSEvents.removedFromWishlist) events.push(swat.JSEvents.removedFromWishlist)
    }
    events.push('sw:addedtowishlist', 'sw:removedfromwishlist')

    events.forEach(function (eventName) {
      if (!eventName) return
      swat.evtLayer.addEventListener(eventName, function () {
        updateWishlistCount(swat)
      })
    })
  }

  paintCachedCount()

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintCachedCount)
  }

  window.SwymCallbacks = window.SwymCallbacks || []
  window.SwymCallbacks.push(bindWishlistCountEvents)

  if (window._swat) {
    bindWishlistCountEvents(window._swat)
  }

  window.updateSwymWishlistCount = updateWishlistCount
  window.paintSwymWishlistCountCache = paintCachedCount
})()
